export const items = item => {
  const {
    westernDiagnosisList = [],
    chineseDiagnosisList = [],
    chinesePrescriptionInfo = {},
    prescriptionNumber = ''
  } = item
  const itemArr = [
    {
      label: '方号：',
      value: prescriptionNumber
    },
    {
      label: '诊断：',
      value: JsonArray(westernDiagnosisList, 'diagnosisName')
    },
    {
      label: '证型：',
      value: JsonArray(chineseDiagnosisList, 'diagnosisName')
    },
    {
      label: '功效：',
      value: chinesePrescriptionInfo?.efficacy
    }
  ]
  return itemArr
}

export const detailList = info => {
  const {
    prescriptionName = '',
    sourceType,
    agencyIdDesc = '',
    chinesePrescriptionInfo = {},
    westernDiagnosisList = [],
    chineseDiagnosisList = [],
    usageDosage = {},
    relationDoctor,
    ingredientInfo = null
  } = info
  const {
    cycle = '',
    usageMethod = '',
    medicationFrequency = '',
    useQuantityStr = '',
    cycleUnit = '',
    usageTime = ''
  } = usageDosage || {}

  // 类型
  const customSourceType = () => {
    if (sourceType == 1) {
      return '平台推荐'
    } else if (sourceType == 3 && relationDoctor == 0) {
      return '医生合作'
    } else if (sourceType == 3 && relationDoctor == 1) {
      return '科室合作'
    }
    return '未知'
  }
  // 药材
  const customMedicineName = () => {
    try {
      if (!ingredientInfo || ingredientInfo.length <= 0) {
        return '已隐藏'
      } else {
        const list = ingredientInfo?.map(item => item.medicineName)
        return list?.join('，')
      }
    } catch (e) {
      return '已隐藏'
    }
  }

  // 用法用量
  const customUsageAndDosage = () => {
    try {
      return (
        usageMethod +
        '，' +
        medicationFrequency +
        '，' +
        useQuantityStr +
        cycleUnit +
        '，' +
        usageTime
      )
    } catch (e) {
      return ''
    }
  }
  const resList = [
    {
      label: '协定方名称',
      key: 'prescriptionName',
      value: prescriptionName
    },
    {
      label: '类型',
      key: 'sourceType',
      value: customSourceType()
    },
    {
      label: '剂型',
      key: 'dosageTypeStr',
      value: chinesePrescriptionInfo.dosageTypeStr
    },
    {
      label: '诊断',
      key: 'westernDiagnosisList',
      value: JsonArray(westernDiagnosisList, 'diagnosisName')
    },
    {
      label: '中医证型',
      key: 'chineseDiagnosisList',
      value: JsonArray(chineseDiagnosisList, 'diagnosisName')
    },
    {
      label: '互联网医院',
      key: 'agencyIdDesc',
      value: agencyIdDesc
    },
    {
      label: '药材',
      key: 'medicineName',
      value: customMedicineName()
    },
    {
      label: '用药周期',
      key: 'cycle',
      value: cycle + cycleUnit
    },
    {
      label: '用法用量',
      key: 'usageDosage',
      value: customUsageAndDosage()
    },
    {
      label: '嘱托',
      key: 'prescriptionTabooInfo',
      value: chinesePrescriptionInfo?.prescriptionTabooInfo?.join('，')
    },
    {
      label: '功效',
      key: 'efficacy',
      value: chinesePrescriptionInfo?.efficacy
    },
    {
      label: '适用人群',
      key: 'indications',
      value: chinesePrescriptionInfo?.indications
    },
    {
      label: '推荐理由',
      key: 'recomReason',
      value: chinesePrescriptionInfo?.recomReason
    }
  ]
  // || ['westernDiagnosisList', 'chineseDiagnosisList'].includes(item.key)
  const res = resList.filter(item => item.value)
  return res
}

export const JsonArray = (arr, key) => {
  const str = arr.map(item => item[key]).join('；')
  return str
}

export const getPrice = price => {
  try {
    // 切割价格区分小数和整数
    const [int, decimal] = price.toString().split('.')
    return {
      int: int || '0',
      decimal: decimal || '00'
    }
  } catch (error) {
    return {
      int: '0',
      decimal: '00'
    }
  }
}
